import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { PasswordModel } from '../auth.models';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { NotificationType } from '../../interfaces/notification.enums';
import { ClientRoles } from '../../services/auth/auth.models'


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy{

  public resetPasswordForm: FormGroup;
  public isLoading = false;
  public submitted = false;
  public submittedPassword = false;
  public token: string;

  private subs: Array<Subscription> = [];

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.required],
      ConfirmedPassword: ['', [Validators.required]]
    })

    this.subs.push(
        this.activatedRoute.paramMap.pipe(
          map(params => params.get('token')),
          switchMap(token => this.token = token)
        ).subscribe(resolve => {   
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public get formState() {
    return this.resetPasswordForm.controls
  }

  private passwordUser(): PasswordModel {
    return {
        password: this.resetPasswordForm.controls['password'].value
    }
  }

  private validatePasswords(): void {
    const password: string = this.resetPasswordForm.get('password').value;
    const confirmPassword: string = this.resetPasswordForm.get('ConfirmedPassword').value;

    if (password !== confirmPassword) {
        this.resetPasswordForm.controls['ConfirmedPassword'].setErrors({ incorrect: true });
    };
}

  public onSubmit(): void {
    this.submittedPassword = true;
    this.validatePasswords();

    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.onResetPassword();
  }

  private onResetPassword() {
    const password: PasswordModel = this.passwordUser();
    this.isLoading = true;
    this.subs.push(
      this.authService.resetPassword(password, this.token)
        .subscribe(resolve => {
            this.handlePasswordChange();
            setTimeout(() => {
                this.router.navigateByUrl('/admin');
            }, 1800);
        }, error =>{
            this.handleError(error)
        })
    );
  }

  private handlePasswordChange() {
    this.isLoading = false;
    this.toastr.success('Contraseña actualizada correctamente', 'Atención ciudadana', { timeOut: 1800 });
  }

  private handleError(error: any) {
    this.isLoading = false;
    this.toastr.error('No hemos podido actualizar la contraseña', 'Error', { timeOut: 2000 });
    return [];
}

}
